import { render, staticRenderFns } from "./ContractKits.vue?vue&type=template&id=064ab6de"
import script from "./ContractKits.vue?vue&type=script&lang=js"
export * from "./ContractKits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports